export * from './color';
export * from './size';


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-styles/es6/styles/index.js
// module id = 370
// module chunks = 0